import { SERVICES_NAMES, SERVICES_TYPES } from "Achat/Constants";
import { useTranslation } from "react-i18next";
import { getStringEndingNumbers } from "./achatUtils";

// #region UTILS
/**
 * Hook qui retourne le bon libellé de service en fonction de la langue actuelle
 * @function
 * @category Achat
*/
const useGetServiceNameLibelle = (serviceName) => {
  let result = serviceName;
  const { t } = useTranslation();

  if (!serviceName) {
    return null;
  }

  const upperName = serviceName.slice(0, 3).toUpperCase();
  const numbers = getStringEndingNumbers(serviceName);

  //AYB 26.08.25 affichage traduit de EAU_ELEC (sinon le prefixe EAU tombe sur "Eau")
  const normalizedName = serviceName.trim().toUpperCase().replace(/\s+/g, "_");
  if (normalizedName.startsWith("EAU_ELEC")) {
    result = t("services_types.eau_elec");
    if (numbers) {
      result = `${result} ${numbers}`;
    }
    return result;
  }

  switch (upperName) {
    case SERVICES_NAMES.ACCES:
      result = t("services_name.acces");
      break;
    case SERVICES_NAMES.EAU_VIDANGE:
      result = t("services_name.eau");
      break;
    case SERVICES_NAMES.ELECTRICICTE:
      result = t("services_name.elec");
      break;
    case SERVICES_NAMES.PARKING:
      result = t("services_name.park");
      break;
    case SERVICES_NAMES.PRISE:
      result = t("services_name.prise");
      break;
    case SERVICES_NAMES.ROB:
      result = t("services_name.robinet");
      break;
    case SERVICES_NAMES.STATIONNEMENT:
      result = t("services_name.stationnement");
      break;
    case SERVICES_NAMES.TAXE:
      result = t("services_name.tax");
      break;

    default:
      return serviceName;
  }

  // On rajoute les nombres de fin si il y en a dans la chaine de base
  if (numbers) {
    result = `${result} ${numbers}`
  }

  return result;
}

/**
 * Hook qui retourne le bon libellé de type de service en fonction de la langue actuelle
 * @function
 * @category Achat
*/
const useGetServiceTypeLibelle = (idServiceType) => {
  const { t } = useTranslation();

  switch (idServiceType) {
    case SERVICES_TYPES.EAU_VIDANGE:
      return t("services_types.eau_vidange");

    case SERVICES_TYPES.ELECTRICICTE:
      return t("services_types.electricite");

    case SERVICES_TYPES.A32:
      return t("services_types.32A");

    case SERVICES_TYPES.PARKING:
      return t("services_types.parking");

    case SERVICES_TYPES.EAU_VIDANGE2:
      return t("services_types.eau_vidange2");

    case SERVICES_TYPES.PRISE_REHARGE:
      return t("services_types.prise_recharge");

    case SERVICES_TYPES.A16:
      return t("services_types.16A");

    case SERVICES_TYPES.EAU_ELEC:
      return t("services_types.eau_elec");

    case SERVICES_TYPES.ACCES_TEMPORAIRE:
      return t("services_types.acces_temporaire");

    case SERVICES_TYPES.TAXE_SEJOUR:
      return t("services_types.taxe_sejour");

    case SERVICES_TYPES.A63:
      return t("services_types.63A");

    case SERVICES_TYPES.STATIONNEMENT_DEMONSTRATEUR:
      return t("services_types.stationnement_demonstrateur");

    case SERVICES_TYPES.TEST:
      return t("services_types.test");

    default:
      break;
  }
}
// #endregion

export {
  useGetServiceNameLibelle,
  useGetServiceTypeLibelle
};

